/*
 * Quack & Lola: single pair -> Set (+ FREE Travel Pouch)
 *
 * When the cart holds a Quack single and a Lola single from the same holiday
 * series, swap them for the matching Set variant. The Set is a native Shopify
 * bundle (Quack + Lola + Travel Pouch), so the pouch, inventory and ShipMonk
 * flow are handled by Shopify. Price is unchanged ($18 + $18 = $36 Set).
 *
 * If the Set cannot be added (e.g. pouch sold out), the singles stay as they are.
 *
 * While a check/swap is in progress, checkout buttons are locked. A checkout
 * click during the lock is held and resumed once the swap has finished.
 */
(function () {
  if (window.QLPairToSet) return;

  // Same-series pairs only. Numeric variant IDs.
  var PAIRS = [
    { name: 'Mini Keychain', set: 67769083986240, quack: 51068172042560, lola: 51068172075328 }, // QL-TO-011-SET-MK
    { name: 'Snowboarding', set: 67769083920704, quack: 67757176258880, lola: 67757176389952 }, // QL-TO-011-SET-SB
    { name: 'Ugly Sweater', set: 67769083953472, quack: 67757176422720, lola: 67757176455488 }, // QL-TO-011-SET-US
  ];
  var SOURCE = 'ql-pair-to-set';
  var NOTICE = 'Your Quack & Lola pair has been upgraded to the Set with a FREE Travel Pouch (same price).';

  var BUSY_CLASS = 'ql-pair-busy';
  var BUSY_TIMEOUT_MS = 10000;

  var running = false;
  var pending = false;
  var reloading = false;
  var resumeCheckout = false;
  var busyTimer = null;

  // --- Checkout lock -------------------------------------------------------

  function injectStyle() {
    var style = document.createElement('style');
    style.textContent =
      'html.' + BUSY_CLASS + ' [name="checkout"],' +
      'html.' + BUSY_CLASS + ' .additional-checkout-buttons{opacity:.5;cursor:wait;}' +
      'html.' + BUSY_CLASS + ' .additional-checkout-buttons{pointer-events:none;}';
    document.head.appendChild(style);
  }

  function isBusy() {
    return document.documentElement.classList.contains(BUSY_CLASS);
  }

  function setBusy(on) {
    document.documentElement.classList.toggle(BUSY_CLASS, on);
    clearTimeout(busyTimer);
    // Never leave checkout locked if something hangs.
    if (on) busyTimer = setTimeout(function () { setBusy(false); }, BUSY_TIMEOUT_MS);
  }

  function goToCheckout() {
    window.location.href = '/checkout';
  }

  function isCheckoutTrigger(event) {
    var target = event.target;
    if (event.type === 'submit') {
      // Cart forms (drawer and cart page) submit to /cart with name="checkout".
      return !!(event.submitter && event.submitter.name === 'checkout');
    }
    return !!(target && target.closest && target.closest('[name="checkout"]'));
  }

  function holdCheckout(event) {
    if (!isBusy() || !isCheckoutTrigger(event)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    resumeCheckout = true;
  }

  function cartUrl(path) {
    var base = (window.routes && window.routes.cart_url) || '/cart';
    return base + path;
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (res) {
      return res.json().then(function (json) {
        return { ok: res.ok, json: json };
      });
    });
  }

  function getCart() {
    return fetch(cartUrl('.js'), { headers: { Accept: 'application/json' } }).then(function (res) {
      return res.json();
    });
  }

  // Lines with custom properties are left alone.
  function plainLines(cart, variantId) {
    return cart.items.filter(function (item) {
      return item.variant_id === variantId && !(item.properties && Object.keys(item.properties).length);
    });
  }

  function sum(lines) {
    return lines.reduce(function (total, item) {
      return total + item.quantity;
    }, 0);
  }

  function setQty(cart, setId) {
    return sum(
      cart.items.filter(function (item) {
        return item.variant_id === setId;
      })
    );
  }

  // Build `updates` that remove `count` units from the given lines.
  function decrement(updates, lines, count) {
    lines.forEach(function (item) {
      if (count <= 0) return;
      var take = Math.min(item.quantity, count);
      updates[item.key] = item.quantity - take;
      count -= take;
    });
  }

  function swapPair(cart, pair) {
    var quackLines = plainLines(cart, pair.quack);
    var lolaLines = plainLines(cart, pair.lola);
    var count = Math.min(sum(quackLines), sum(lolaLines));
    if (count <= 0) return Promise.resolve(false);

    var before = setQty(cart, pair.set);

    // 1) Add the Set first. If it fails (sold out etc.), nothing has changed.
    //    When stock is short, retry with fewer Sets.
    function addSets(n) {
      if (n <= 0) return Promise.resolve({ ok: false });
      return postJSON(cartUrl('/add.js'), { items: [{ id: pair.set, quantity: n }] }).then(function (res) {
        return res.ok ? res : addSets(n - 1);
      });
    }

    return addSets(count)
      .then(function (res) {
        if (!res.ok) return false;
        return getCart().then(function (afterAdd) {
          // Only swap as many pairs as were actually added.
          var added = setQty(afterAdd, pair.set) - before;
          if (added <= 0) return false;

          var updates = {};
          decrement(updates, plainLines(afterAdd, pair.quack), added);
          decrement(updates, plainLines(afterAdd, pair.lola), added);

          // 2) Remove the singles. On failure, take the added Sets back out.
          return postJSON(cartUrl('/update.js'), { updates: updates }).then(function (upd) {
            if (upd.ok) return true;
            var rollback = {};
            rollback[pair.set] = before;
            return postJSON(cartUrl('/update.js'), { updates: rollback }).then(function () {
              return false;
            });
          });
        });
      })
      .catch(function (e) {
        console.error('[ql-pair-to-set]', e);
        return false;
      });
  }

  function refreshUI() {
    // Cart page: simplest correct refresh.
    if (document.getElementById('main-cart-items')) {
      reloading = true;
      if (resumeCheckout) goToCheckout();
      else window.location.reload();
      return Promise.resolve();
    }

    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return Promise.resolve();

    return fetch(cartUrl('?sections=cart-drawer,cart-icon-bubble'))
      .then(function (res) {
        return res.json();
      })
      .then(function (sections) {
        var parse = function (html, selector) {
          var el = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
          return el ? el.innerHTML : null;
        };
        var drawerInner = document.getElementById('CartDrawer');
        var drawerHTML = sections['cart-drawer'] && parse(sections['cart-drawer'], '#CartDrawer');
        if (drawerInner && drawerHTML !== null) {
          drawerInner.innerHTML = drawerHTML;
          var overlay = drawer.querySelector('#CartDrawer-Overlay');
          if (overlay) overlay.addEventListener('click', drawer.close.bind(drawer));
        }
        var bubble = document.getElementById('cart-icon-bubble');
        var bubbleHTML = sections['cart-icon-bubble'] && parse(sections['cart-icon-bubble'], '.shopify-section');
        if (bubble && bubbleHTML !== null) bubble.innerHTML = bubbleHTML;
      })
      .catch(function (e) {
        console.error('[ql-pair-to-set]', e);
      });
  }

  function showNotice() {
    var el = document.createElement('div');
    el.setAttribute('role', 'status');
    el.textContent = NOTICE;
    el.style.cssText =
      'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);z-index:2147483647;' +
      'max-width:min(92vw,420px);padding:12px 16px;border-radius:8px;background:#222;color:#fff;' +
      'font-size:14px;line-height:1.4;box-shadow:0 4px 16px rgba(0,0,0,.25);text-align:center;';
    document.body.appendChild(el);
    setTimeout(function () {
      el.remove();
    }, 6000);
  }

  function reconcile() {
    if (running) {
      pending = true;
      return Promise.resolve(false);
    }
    running = true;
    setBusy(true);

    var changed = false;
    return getCart()
      .then(function (cart) {
        // Run pairs one after another; re-read the cart between swaps.
        return PAIRS.reduce(function (chain, pair) {
          return chain.then(function (current) {
            return swapPair(current, pair).then(function (swapped) {
              if (!swapped) return current;
              changed = true;
              return getCart();
            });
          });
        }, Promise.resolve(cart));
      })
      .then(function () {
        if (!changed) return;
        try {
          sessionStorage.setItem('ql-pair-to-set-notice', '1');
        } catch (e) {}
        return refreshUI().then(function () {
          if (typeof PUB_SUB_EVENTS !== 'undefined' && typeof publish === 'function') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: SOURCE });
          }
        });
      })
      .catch(function (e) {
        console.error('[ql-pair-to-set]', e);
      })
      .then(function () {
        running = false;
        if (pending) {
          pending = false;
          return reconcile();
        }
        if (reloading) return changed;
        setBusy(false);
        if (resumeCheckout) {
          resumeCheckout = false;
          goToCheckout();
          return changed;
        }
        if (changed) maybeShowNotice();
        return changed;
      });
  }

  function maybeShowNotice() {
    try {
      if (sessionStorage.getItem('ql-pair-to-set-notice') !== '1') return;
      sessionStorage.removeItem('ql-pair-to-set-notice');
    } catch (e) {}
    showNotice();
  }

  window.QLPairToSet = { reconcile: reconcile, PAIRS: PAIRS, isBusy: isBusy };

  injectStyle();
  document.addEventListener('click', holdCheckout, true);
  document.addEventListener('submit', holdCheckout, true);

  if (typeof PUB_SUB_EVENTS !== 'undefined' && typeof subscribe === 'function') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event && event.source === SOURCE) return;
      reconcile();
    });
  }

  // Carts built on earlier visits, and the notice after a cart-page reload.
  maybeShowNotice();
  reconcile();
})();
